/* @flow */

import type { $LanguageTemplate } from "CoreTypes/Template";
import Globals from "../constants/Globals";
import WidgetGenericKeys from "../constants/FieldKeysGeneric";
import DDWFieldKeys from "./../constants/FieldKeysDDW";
import DSWFieldKeys from "./../constants/FieldKeysDSW";
import SPAFieldKeys from "./../constants/FieldKeysSPA";
import OneDLCFieldKeys from "./../constants/FieldKeysOneDLC";

const TemplateTranslations: Array<$LanguageTemplate> = [
  {
    key: WidgetGenericKeys.PREFIX_PHONE,
    name: "Generic text for phone number prefix",
    defaultTranslation: "Tel."
  },
  {
    key: WidgetGenericKeys.PREFIX_FAX,
    name: "Generic text for fax number prefix",
    defaultTranslation: "Fax."
  },
  {
    key: WidgetGenericKeys.PREFIX_EMAIL,
    name: "Generic text for email address prefix",
    defaultTranslation: ""
  },
  {
    key: WidgetGenericKeys.HERE_MAPS_LANGUAGE,
    name: "Default language for HERE maps",
    defaultTranslation: "eng"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_MONDAY,
    name: "Weekdays translation: Monday",
    defaultTranslation: "Monday"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_TUESDAY,
    name: "Weekdays translation: Tuesday",
    defaultTranslation: "Tuesday"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_WEDNESDAY,
    name: "Weekdays translation: Wednesday",
    defaultTranslation: "Wednesday"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_THURSDAY,
    name: "Weekdays translation: Thursday",
    defaultTranslation: "Thursday"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_FRIDAY,
    name: "Weekdays translation: Friday",
    defaultTranslation: "Friday"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_SATURDAY,
    name: "Weekdays translation: Saturday",
    defaultTranslation: "Saturday"
  },
  {
    key: WidgetGenericKeys.WEEKDAY_SUNDAY,
    name: "Weekdays translation: Sunday",
    defaultTranslation: "Sunday"
  },
  {
    key: WidgetGenericKeys.DISTANCE_UNIT_KM,
    name: "Distance unit: kilometers",
    defaultTranslation: "km"
  },
  {
    key: WidgetGenericKeys.DISTANCE_UNIT_MI,
    name: "Distance unit: miles",
    defaultTranslation: "mi"
  },
  {
    key: WidgetGenericKeys.DISTANCE_UNIT_M,
    name: "Distance unit: meters",
    defaultTranslation: "m"
  },
  {
    key: WidgetGenericKeys.DISTANCE_UNIT_YD,
    name: "Distance unit: yards",
    defaultTranslation: "yd"
  },
  {
    key: WidgetGenericKeys.DEALERS_SEARCH_TAB_LABEL_LOCATION,
    name: "Dealers search tab label: by location",
    defaultTranslation: "By location"
  },
  {
    key: WidgetGenericKeys.DEALERS_SEARCH_TAB_LABEL_NAME,
    name: "Dealers search tab label: by dealer name",
    defaultTranslation: "By dealer name"
  },
  {
    key: WidgetGenericKeys.DEALERS_SEARCH_SUBMIT_BUTTON_LABEL,
    name: "Dealers search form submit button label",
    defaultTranslation: "Search"
  },
  {
    key: WidgetGenericKeys.DEALERS_SEARCH_FIELD_PLACEHOLDER_LOCATION,
    name: "Dealers search input field placeholder: location",
    defaultTranslation: "City / postal code"
  },
  {
    key: WidgetGenericKeys.DEALERS_SEARCH_FIELD_PLACEHOLDER_NAME,
    name: "Dealers search input field placeholder: dealer name",
    defaultTranslation: "Dealer name"
  },
  {
    key: WidgetGenericKeys.DEALERS_SEARCH_FIELD_NO_SUGGESTIONS,
    name: "No suggestions found label",
    defaultTranslation: Globals.SEARCH_NO_SUGGESTIONS
  },
  {
    key: WidgetGenericKeys.DEALER_PORTFOLIO_HEADLINE,
    name: "Dealer portfolio headline",
    defaultTranslation: "Services"
  },
  {
    key: WidgetGenericKeys.DEALER_PORTFOLIO_NO_INFO,
    name: "Dealer portfolio message when missing contacts and opening hours",
    defaultTranslation:
      "Please use our main contacts for more information on {productGroup}"
  },
  {
    key: WidgetGenericKeys.DEALER_CONTACTS_HEADLINE,
    name: "Dealer contacts headline",
    defaultTranslation: "Contacts"
  },
  {
    key: WidgetGenericKeys.UNSUPPORTED_BROWSER_WARNING,
    name: "Unsupported browser warning",
    defaultTranslation:
      "You are currently using an obsolete web browser " +
      "which is no longer supported for technical reasons"
  },
  {
    key: WidgetGenericKeys.MAP_GESTURES_ZOOM_TOUCH_LABEL,
    name: "Map gestures zoom handling: touch (mobile devices)",
    defaultTranslation: Globals.MAPS_GESTURES_ZOOM_TOUCH_LABEL
  },
  {
    key: WidgetGenericKeys.MAP_GESTURES_ZOOM_SCROLL_LABEL,
    name: "Map gestures zoom handling: mouse scroll",
    defaultTranslation: Globals.MAPS_GESTURES_ZOOM_SCROLL_LABEL
  },
  {
    key: WidgetGenericKeys.MAP_GESTURES_ZOOM_SCROLL_MAC_LABEL,
    name: "Map gestures zoom handling: mouse scroll (MacOSX)",
    defaultTranslation: Globals.MAPS_GESTURES_ZOOM_SCROLL_MAC_LABEL
  },
  {
    key: WidgetGenericKeys.PARAGRAPH_RESULTS_COUNT,
    name: "Text for the results count paragraph in DSW & SPA",
    defaultTranslation: "We found {numResults} results"
  },
  {
    key: WidgetGenericKeys.PARAGRAPH_RESULTS_COUNT_SINGULAR,
    name:
      "Text for the results count paragraph in DSW & SPA when there is only one result",
    defaultTranslation: "We found {numResults} result"
  },
  {
    key: DDWFieldKeys.HEADLINE_CONTACT_PERSON_OPENING_HOURS,
    name: "Text for contact person opening hours headline",
    defaultTranslation: "Opening hours"
  },
  {
    key: DDWFieldKeys.PORTFOLIO_OPENING_HOURS_CLOSED,
    name: "Text for closed opening hours label",
    defaultTranslation: "Closed"
  },
  {
    key: DDWFieldKeys.LINK_HOMEPAGE_CTA,
    name: "DDW homepage CTA label",
    defaultTranslation: "Website"
  },
  {
    key: DDWFieldKeys.LINK_HOMEPAGE_CTA_URL,
    name: "DDW homepage CTA URL",
    defaultTranslation: "https://www.mercedes-benz.io/"
  },
  {
    key: DDWFieldKeys.LINK_EMAIL_CTA,
    name: "DDW email CTA label",
    defaultTranslation: "Email"
  },
  {
    key: DDWFieldKeys.LINK_EMAIL_CTA_URL,
    name: "DDW email CTA URL",
    defaultTranslation: "https://www.mercedes-benz.io/"
  },
  {
    key: DDWFieldKeys.LINK_ROUTE_CTA,
    name: "DDW route CTA label",
    defaultTranslation: "Route"
  },
  {
    key: DDWFieldKeys.LINK_ROUTE_CTA_URL,
    name: "DDW route CTA URL",
    defaultTranslation: "https://wego.here.com/directions"
  },
  {
    key: DDWFieldKeys.LINK_HOMEPAGE,
    name: "Text for homepage link in DDW",
    defaultTranslation: "Homepage"
  },
  {
    key: DDWFieldKeys.LINK_HOMEPAGE_URL,
    name: "URL for homepage link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/"
  },
  {
    key: DDWFieldKeys.LINK_ONLINE_SHOP,
    name: "Text for online shop link in DDW",
    defaultTranslation: "Online Shop"
  },
  {
    key: DDWFieldKeys.LINK_ONLINE_SHOP_URL,
    name: "URL for online shop link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/online-shop"
  },
  {
    key: DDWFieldKeys.LINK_ONLINE_SERVICE,
    name: "Text for online service link in DDW",
    defaultTranslation: "Online Service"
  },
  {
    key: DDWFieldKeys.LINK_ONLINE_SERVICE_URL,
    name: "URL for online service link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/online-service"
  },
  {
    key: DDWFieldKeys.LINK_LOCATION,
    name: "Text for how to find us link in DDW",
    defaultTranslation: "How to Find Us"
  },
  {
    key: DDWFieldKeys.LINK_LOCATION_URL,
    name: "URL for how to find us link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/location"
  },
  {
    key: DDWFieldKeys.LINK_CALLBACK,
    name: "Text for callback link in DDW",
    defaultTranslation: "Callback"
  },
  {
    key: DDWFieldKeys.LINK_CALLBACK_URL,
    name: "URL for callback link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/callback"
  },
  {
    key: DDWFieldKeys.LINK_SEND_REQUEST,
    name: "Text for send request link in DDW",
    defaultTranslation: "Send Request"
  },
  {
    key: DDWFieldKeys.LINK_SEND_REQUEST_URL,
    name: "URL for send request link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/send-request"
  },
  {
    key: DDWFieldKeys.LINK_TEST_DRIVE,
    name: "Text for test drive link in DDW",
    defaultTranslation: "Test Drive"
  },
  {
    key: DDWFieldKeys.LINK_TEST_DRIVE_URL,
    name: "URL for test drive link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/test-drive"
  },
  {
    key: DDWFieldKeys.LINK_CUSTOM_1,
    name: "Text for custom 1 link in DDW",
    defaultTranslation: "Custom 1"
  },
  {
    key: DDWFieldKeys.LINK_CUSTOM_1_URL,
    name: "URL for custom 1 link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/custom-1"
  },
  {
    key: DDWFieldKeys.LINK_CUSTOM_2,
    name: "Text for custom 2 link in DDW",
    defaultTranslation: "Custom 2"
  },
  {
    key: DDWFieldKeys.LINK_CUSTOM_2_URL,
    name: "URL for custom 2 link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/custom-2"
  },
  {
    key: DDWFieldKeys.LINK_CUSTOM_3,
    name: "Text for custom 3 link in DDW",
    defaultTranslation: "Custom 3"
  },
  {
    key: DDWFieldKeys.LINK_CUSTOM_3_URL,
    name: "URL for custom 3 link in DDW",
    defaultTranslation: "https://www.mercedes-benz.io/custom-3"
  },
  {
    key: DSWFieldKeys.HEADLINE_WIDGET,
    name: "Text for widget headline in DSW",
    defaultTranslation: "Search for a Mercedes-Benz partner"
  },
  {
    key: DSWFieldKeys.BUTTON_DEALER_SELECT,
    name: "Text for the select dealer buttons in DSW",
    defaultTranslation: "Select this dealer"
  },
  {
    key: DSWFieldKeys.BUTTON_LOCATE_ME_TOOLTIP,
    name: "Text for the geolocation button in DSW",
    defaultTranslation: "Locate me"
  },
  {
    key: DSWFieldKeys.INPUT_SEARCH_PLACEHOLDER,
    name: "Placeholder text for search input in DSW",
    defaultTranslation: "Name / Postal code / City"
  },
  {
    key: DSWFieldKeys.BUTTON_SEARCH,
    name: "Text for the search button in DSW",
    defaultTranslation: "Search"
  },
  {
    key: DSWFieldKeys.PARAGRAPH_RESULTS_SUGGESTED_COUNT,
    name:
      "Text for the results count paragraph and the suggested criteria in DSW",
    defaultTranslation: "We found {numResults} results for {suggestedSearch}"
  },
  {
    key: DSWFieldKeys.PARAGRAPH_SEARCH_INSTEAD_LINK,
    name: "Text for original search expression link",
    defaultTranslation: "Search for {originalSearch} instead"
  },
  {
    key: DSWFieldKeys.TAB_MODE_LIST,
    name: "Text for the list mode tab in DSW",
    defaultTranslation: "List view"
  },
  {
    key: DSWFieldKeys.TAB_MODE_MAP,
    name: "Text for the map mode tab in DSW",
    defaultTranslation: "Map view"
  },
  {
    key: DSWFieldKeys.DROPDOWN_FILTER,
    name: "Text for the filter dropdown label in DSW",
    defaultTranslation: "Filter results"
  },
  {
    key: SPAFieldKeys.SPA_HEADLINE,
    name: "SPA application headline",
    defaultTranslation: "Search for a Mercedes-Benz partner"
  },
  {
    key: SPAFieldKeys.SPA_HEADLINE_SUB,
    name: "SPA application subheadline",
    defaultTranslation: `Search for your nearest dealer by entering it's name, postcode, city or town name`
  },
  {
    key: SPAFieldKeys.SPA_SEARCH_LOCATE_ME,
    name: "'Locate me' label",
    defaultTranslation: "Search nearby"
  },
  {
    key: SPAFieldKeys.SPA_PGPH_NO_RESULTS_LABEL,
    name: "No results paragraph text",
    defaultTranslation:
      "No Mercedes-Benz partners have been found for the search criteria provided"
  },
  {
    key: SPAFieldKeys.SPA_PGPH_BACK_TO_MAP_LABEL,
    name: "'Return to map' label",
    defaultTranslation: "Back to map"
  },
  {
    key: SPAFieldKeys.SPA_PGPH_BACK_TO_LIST_LABEL,
    name: "'Return to list' label",
    defaultTranslation: "Back to results list"
  },
  {
    key: SPAFieldKeys.FILTERING_SEARCH_RADIUS_LABEL,
    name: "Filter by search radius label",
    defaultTranslation: "Filter by radius"
  },
  {
    key: WidgetGenericKeys.FILTERING_ACTIVITY_TYPES_LABEL,
    name: "Filter by activity type label",
    defaultTranslation: "Filter by activity type"
  },
  {
    key: SPAFieldKeys.FILTERING_PRODUCT_GROUPS_LABEL,
    name: "Filter by product group label",
    defaultTranslation: "Filter by product group"
  },
  {
    key: WidgetGenericKeys.PRODUCT_GROUP_DROPDOWN_DESCRIPTION_LABEL,
    name: "Description for dropdown filter: product group",
    defaultTranslation: "Filter by product group"
  },
  {
    key: WidgetGenericKeys.ACTIVITY_TYPE_DROPDOWN_DESCRIPTION_LABEL,
    name: "Description for dropdown filter: activity types",
    defaultTranslation: "Filter by activity type"
  },
  {
    key: OneDLCFieldKeys.PORTFOLIO_SERVICE_MESSAGE_LINE1,
    name: "Description for Service Message, line 1",
    defaultTranslation: "none"
  },
  {
    key: OneDLCFieldKeys.PORTFOLIO_SERVICE_MESSAGE_LINE2,
    name: "Description for Service Message, line 2",
    defaultTranslation: "none"
  },
  {
    key: OneDLCFieldKeys.RESET_FILTERS,
    name: "Description for reset filters label",
    defaultTranslation: "Reset filters"
  },
  {
    key: OneDLCFieldKeys.OPEN_FILTERS_TOOLTIP,
    name: "Open filters tooltip",
    defaultTranslation: "Show filters"
  },
  {
    key: OneDLCFieldKeys.CLOSE_FILTERS_TOOLTIP,
    name: "Close filters tooltip",
    defaultTranslation: "Hide filters"
  },
  {
    key: OneDLCFieldKeys.DEALERS_SEARCH_FIELD_LABEL_LOCATION,
    name: "Placehoder for search by location (in search input)",
    defaultTranslation: "Search by Location"
  },
  {
    key: OneDLCFieldKeys.DEALERS_SEARCH_FIELD_LABEL_NAME,
    name: "Placehoder for search by dealer name (in search input)",
    defaultTranslation: "Search by Dealer Name"
  },
  {
    key: OneDLCFieldKeys.DEALERS_SEARCH_LOAD_MORE_LABEL,
    name: "Label for button to load more dealers",
    defaultTranslation: "Load More"
  },
  {
    key: OneDLCFieldKeys.BOTTOM_BAR_MORE_INFO_LABEL,
    name: "Secondary button of bottom bar (normally to view more info)",
    defaultTranslation: "More info"
  },
  {
    key: OneDLCFieldKeys.LINK_PHONE_CTA,
    name: "Text for Phone CTA",
    defaultTranslation: "Phone"
  },
  {
    key: OneDLCFieldKeys.LINK_PHONE_CTA_URL,
    name: "Phone CTA URL",
    defaultTranslation: "none"
  },
  {
    key: OneDLCFieldKeys.LINK_NEW_CARS_CTA,
    name: "Text for New Cars CTA",
    defaultTranslation: "New Cars"
  },
  {
    key: OneDLCFieldKeys.LINK_NEW_CARS_CTA_URL,
    name: "New Cars CTA URL",
    defaultTranslation: "none"
  },
  {
    key: OneDLCFieldKeys.LINK_USED_CARS_CTA,
    name: "Text for Used Cars CTA",
    defaultTranslation: "Used Cars"
  },
  {
    key: OneDLCFieldKeys.LINK_USED_CARS_CTA_URL,
    name: "Used Cars CTA URL",
    defaultTranslation: "none"
  },
  {
    key: OneDLCFieldKeys.LINK_GENERIC_CARS_CTA,
    name: "Text for Generic Cars CTA",
    defaultTranslation: "Certified Used Cars"
  },
  {
    key: OneDLCFieldKeys.LINK_GENERIC_CARS_CTA_URL,
    name: "Generic Cars CTA URL",
    defaultTranslation: "none"
  },
  {
    key: OneDLCFieldKeys.DEALER_BOOKINGS_HEADLINE,
    name: "Description for bookings CTA group",
    defaultTranslation: "Bookings"
  },
  {
    key: OneDLCFieldKeys.DEALER_STORE_HEADLINE,
    name: "Description for store CTA group",
    defaultTranslation: "Store / Sales"
  },
  {
    key: OneDLCFieldKeys.DEALER_LINKOUTS_HEADLINE,
    name: "Description for linkouts CTA group",
    defaultTranslation: "Links"
  },
  {
    key: OneDLCFieldKeys.AIR_DISTANCE_LABEL,
    name: "Description for air distance label",
    defaultTranslation: "Air distance"
  },
  {
    key: OneDLCFieldKeys.DRIVING_DISTANCE_LABEL,
    name: "Description for driving distance label",
    defaultTranslation: "Driving distance"
  },
  {
    key: OneDLCFieldKeys.TOPBAR_TOGGLE,
    name:
      "Description for the top bar toggle (normally used for multiselection of dealers",
    defaultTranslation: "Select dealer"
  },
  {
    key: OneDLCFieldKeys.DEEP_LINK_HEADLINE,
    name: "DeeplinkGroup - Headline for a Dealer Group Deeplink",
    defaultTranslation: "Search for more Mercedes-Benz dealers in our group"
  },
  {
    key: OneDLCFieldKeys.SHOW_ALL_DEALERS,
    name:
      "DeeplinkGroup - Description of topbar button when showing a dealer of a group",
    defaultTranslation: "Show all dealers"
  },
  {
    key: OneDLCFieldKeys.DEALERS_RETAIL_HEADLINE,
    name: "RetailView - Headline of dealers List",
    defaultTranslation: "Dealers / Concessionários"
  },
  {
    key: OneDLCFieldKeys.LOCATE_ME_BLOCKED,
    name: "Blocked permission - Locate Me label",
    defaultTranslation: "Location blocked in the browser"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_AMG,
    name: "highlight label - AMG",
    defaultTranslation: "AMG"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_EQ,
    name: "highlight label - EQ",
    defaultTranslation: "EQ"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_EQCHARGER,
    name: "highlight label - EQ Charger",
    defaultTranslation: "EQ Charger"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_PARTSPRO,
    name: "highlight label - Parts Pro",
    defaultTranslation: "Parts Pro"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_WEBPARTS,
    name: "highlight label - Web Parts",
    defaultTranslation: "Web Parts"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_JUNGESTERNE,
    name: "highlight label - Junge Sterne",
    defaultTranslation: "Junge Sterne"
  },
  {
    key: OneDLCFieldKeys.HIGHLIGHT_LABEL_MBCERTIFIED,
    name: "highlight label - MB Certified",
    defaultTranslation: "MB Certified"
  },
  {
    key: OneDLCFieldKeys.PHONE_DISCLAIMER_LINE_1,
    name: "Phone disclaimer line 1",
    defaultTranslation: ""
  },
  {
    key: OneDLCFieldKeys.PHONE_DISCLAIMER_LINE_2,
    name: "Phone disclaimer line 2",
    defaultTranslation: ""
  },
  {
    key: OneDLCFieldKeys.PHONE_DISCLAIMER_LINE_3,
    name: "Phone disclaimer line 3",
    defaultTranslation: ""
  }
];

export default TemplateTranslations;
